import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import ConfirmPlugin from './plugins/confirm'
import Vuelidate from 'vuelidate'
import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { fetchUserProfile } from './services/auth'

// Import all validation rules and extend VeeValidate
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

// Configure VeeValidate
configure({
  // Config options
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
})

// Register VeeValidate components globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

// Create a custom v-validate directive for backward compatibility
Vue.directive('validate', {
  bind(el, binding) {
    // For now, just add a data attribute to mark the field as having validation
    el.setAttribute('data-vv-validate-on', 'input|blur')
    el.setAttribute('data-vv-rules', binding.value || '')
  }
})

Vue.use(Vuelidate)
Vue.config.productionTip = false

// Provide $confirm and $alert globally
Vue.use(ConfirmPlugin)

// Función para inicializar el estado de autenticación
const initAuth = async () => {
  const accessToken = localStorage.getItem('access_token')
  const userProfile = localStorage.getItem('user_profile')

  if (accessToken) {
    try {
      // Si hay token pero no hay perfil, obtenerlo
      if (!userProfile) {
        const profile = await fetchUserProfile()
        store.commit('set_user_profile', profile)
      } else {
        store.commit('set_user_profile', JSON.parse(userProfile))
      }

      // Establecer como autenticado
      store.commit('set_authenticated', true)
    } catch (error) {
      console.error('Error inicializando autenticación:', error)
      // Si falla, limpiar tokens inválidos
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('user_profile')
      localStorage.removeItem('app_id')
      localStorage.removeItem('tenant_id')
    }
  }
}

// Inicializar autenticación antes de crear la app
initAuth().then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}).catch(error => {
  console.error('Error en inicialización:', error)
  // Crear la app aunque falle la inicialización
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})
